export default __webpack_public_path__ + "assets/hot.0e88df80.svg";